// App.js

import React, { useContext, useState, useEffect } from 'react';
//import './scss/main.scss';
import './scss/style.scss';
import './scss/App.scss';
import './views/widgets/music-widget.css'
import Spinner from './components/Spinner';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthUserProvider, AuthUserContext } from './views/session/context'; // Correctly import both
import { MusicPlayerProvider } from './views/widgets/MusicPlayerContext';
import GlobalMusicPlayer from './views/widgets/GlobalMusicPlayer';
import routerConfig from './routerConfig';
import setupAxiosInterceptors from './utils/axiosConfig';
import { CartProvider } from './context/CartContext';
import SessionTimer from './components/SessionTimer';

const AppContent = () => {
  const { authUser } = useContext(AuthUserContext);
  return (
    <>
      {routerConfig}
      {/* Only show SessionTimer when user is authenticated */}
      {authUser && <SessionTimer />}
    </>
  );
};

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Enable the axios interceptor setup
    setupAxiosInterceptors();
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <Spinner />;
  }
  
  return (
    <div>
      <AuthUserProvider>
        <MusicPlayerProvider>
          <ToastContainer
            position="top-right"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick={true}
            rtl={false}
            pauseOnFocusLoss={true}
            draggable={true}
            pauseOnHover={true}
            theme="light"
          />
          <CartProvider>
            <AppContent />
            <GlobalMusicPlayer />
          </CartProvider>
        </MusicPlayerProvider>
      </AuthUserProvider>
    </div>
  );
};

export default App;
